import type { MerchantOrderViewItem } from "@/app/[locale]/customer/orders/types"
import { API_ROUTES } from "@/routes"

const merchantIdParam = "merchantId"

export type API_ROUTES_MERCHANT_ONGOING_ORDERS_RETURN = MerchantOrderViewItem[]
export const API_ROUTES_MERCHANT_ONGOING_ORDERS = {
  get: (merchantId: string) => `${API_ROUTES.merchantOngoingOrders}?${merchantIdParam}=${merchantId}`,
  params: {
    merchantId: merchantIdParam,
  },
}
